
export const PlayerBioView = ({ bio }) => {
  return (
    <div className="rounded-2xl p-4 sm:p-6 border-slate-700/50">
      <h3 className="text-white font-bold text-base sm:text-lg mb-3 sm:mb-4">PLAYER BIO</h3>
      <p className="text-slate-300 text-sm sm:text-base leading-relaxed">
        {bio || 'No bio available.'}
      </p>
    </div>
  );
};

export default PlayerBioView;
